import React from "react"

export interface SearchButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: JSX.Element
  label: string
  className: string
  type: "submit" | "button" | "reset"
  onClick?: () => void
}

export const SearchButton = ({ icon, label, className, onClick, type, ...props }: SearchButtonProps) => {
  return (
    <button className={className} {...props} type={type} onClick={onClick}>
      <span className="flex justify-between space-x-4">
        <label className="text-white">{label}</label>
        {icon}
      </span>
    </button>
  )
}
